import { Navigate, useLocation } from 'react-router-dom';
import { Result, Button } from 'antd';
import { useAuth } from '@/hooks/useAuth';
import { ROUTES } from '@/constants/routes';

/**
 * StoreGuard (EG-355 §3) — kiểm tra user có quyền truy cập store hiện tại.
 *
 * - Cashier chưa chọn store → redirect /auth/select-store.
 * - User đang dùng store không nằm trong storeAssignments → 403.
 *
 * Owner (không có storeAssignments) vẫn pass — BE tự scope.
 * Wrap quanh các route business cần biết storeId (POS, inventory, orders).
 * Place sau AuthGuard (PrivateRoute), trước AppLayout.
 */
export function StoreGuard({ element }: { element: React.ReactNode }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user?.role === 'cashier' && !user?.storeId) {
    return (
      <Navigate
        to={ROUTES.auth.selectStore}
        state={{ from: location.pathname }}
        replace
      />
    );
  }

  // Validate storeId ∈ storeAssignments (UI safeguard; BE enforcement là chính)
  if (
    user?.storeId &&
    user?.storeAssignments &&
    user.storeAssignments.length > 0 &&
    !user.storeAssignments.includes(user.storeId)
  ) {
    return (
      <Result
        status="403"
        title="Không có quyền truy cập cửa hàng này"
        subTitle={`Tài khoản không được gán quyền truy cập cửa hàng hiện tại.`}
        extra={
          <Button type="primary" onClick={() => window.history.back()}>
            Quay lại
          </Button>
        }
      />
    );
  }

  return <>{element}</>;
}
